import Centr from './coordinates/Ufa/Centr.json';
import Dema from './coordinates/Ufa/Dema.json';
import Zaton from './coordinates/Ufa/Zaton.json';
import CvetyBashkirii from './coordinates/Ufa/CvetyBashkirii.json';
import CHernikovka from './coordinates/Ufa/CHernikovka.json';
import CHesnokovka from './coordinates/Ufa/CHesnokovka.json';
import Zubovo1 from './coordinates/Ufa/Zubovo1.json';
import Zubovo2 from './coordinates/Ufa/Zubovo2.json';
import Zubovo3 from './coordinates/Ufa/Zubovo3.json';
import KirovskijRajon from './coordinates/Ufa/KirovskijRajon.json';
import Inors from './coordinates/Ufa/Inors.json';
import Knyazevo from './coordinates/Ufa/Knyazevo.json';

export default {
    regionCode: 'ufa',
    serviceAreas: [
        {
            id: 'ufa-1',
            include: [
                {
                    name: 'Центр',
                    type: 'polygon',
                    coordinates: Centr,
                },              
            ],
        },
        {
            id: 'ufa-2',
            include: [
                {
                    name: 'Дема',
                    type: 'polygon',
                    coordinates: Dema,
                },
                {
                    name: 'Затон',
                    type: 'polygon',
                    coordinates: Zaton,
                },
                {
                    name: 'Цветы Башкирии',
                    type: 'polygon',
                    coordinates: CvetyBashkirii,
                },
                {
                    name: 'Черниковка',
                    type: 'polygon',
                    coordinates: CHernikovka,
                },
                {
                    name: 'Кировский район',
                    type: 'polygon',
                    coordinates: KirovskijRajon,
                },                          
            ],
        },
        {
            id: 'ufa-3',
            include: [
                {
                    name: 'Чесноковка',
                    type: 'polygon',
                    coordinates: CHesnokovka,
                },
                {
                    name: 'Инорс',
                    type: 'polygon',
                    coordinates: Inors,
                },
                {
                    name: 'Князево',
                    type: 'polygon',
                    coordinates: Knyazevo,
                },    
                {
                    name: 'Зубово1',
                    type: 'polygon',
                    coordinates: Zubovo1,
                },
                {
                    name: 'Зубово2',
                    type: 'polygon',
                    coordinates: Zubovo2,
                },
                {
                    name: 'Зубово3',
                    type: 'polygon',
                    coordinates: Zubovo3,
                }                                                               
            ],
        },
        {
            id: 'ufa-4',
            include: [
                {
                    name: 'Центр',
                    type: 'polygon',
                    coordinates: Centr,
                },         
            ],
        }                    
    ]
};
